<template>
  <v-dialog persistent eager v-model="dialog" max-width="600">
    <v-card>
      <v-alert v-if="record.actualizado" dark color="warning"
        >Registro Actualizado</v-alert
      >
      <v-alert v-if="record.nuevo" dark color="success"
        >Registro Creado</v-alert
      >
      <v-card-title>
        <span v-if="cursado.espacio"
          >Nuevo Horario {{ cursado.espacio.nombre }}</span
        >
        <v-btn link icon absolute top right @click="cerrar"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </v-card-title>
      <v-card-text>
        <v-form>
          <div v-for="(label, field) in filteredFields" :key="field">
            <slot :name="field" :model="model">
              <v-text-field
                outlined
                v-model="model[field]"
                :label="label"
                :error-messages="errors[field]"
              ></v-text-field>
            </slot>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div>
          <v-btn @click="guardar" color="primary">Guardar</v-btn>
        </div>
        <v-spacer></v-spacer>
        <div>
          <v-btn @click="cerrar">Cancelar</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  name: "HorarioCursadoForm",
  props: {
    cursado: Object,
    id: [String, Number],
    cursado_id: [String, Number],
  },
  data() {
    return {
      dialog: false,
      only: [],
      exclude: [],
      model: {},
    };
  },
  computed: {
    ...mapGetters("NewHorarioCursadoModule", ["errors"]),
    ...mapState("NewHorarioCursadoModule", [
      "fields",
      "horarioCursado",
      "record",
    ]),
    filteredFields() {
      let items = [];
      items = Object.keys(this.fields)
        .filter((key) => !this.only.length > 0 || this.only.includes(key))
        .reduce((obj, key) => {
          obj[key] = this.fields[key];
          return obj;
        }, {});
      items = Object.keys(items)
        .filter((key) => !this.exclude.includes(key))
        .reduce((obj, key) => {
          obj[key] = items[key];
          return obj;
        }, {});
      return items;
    },
  },
  methods: {
    ...mapActions("NewHorarioCursadoModule", [
      "getFields",
      "getHorarioCursado",
      "updateHorarioCursado",
      "addHorarioCursado",
    ]),
    async getModel() {
      await this.getHorarioCursado(this.id);
      this.model = this.horarioCursado;
    },
    async guardar() {
      this.model.cursado_id = this.cursado_id;
      this.model.id
        ? await this.updateHorarioCursado(this.model)
        : await this.addHorarioCursado(this.model);
      // this.$emit('close');
    },
    cerrar() {
      this.record.actualizado = false;
      this.record.nuevo = false;
      this.$emit("close");
    },
  },
  watch: {
    id() {
      if (this.id) {
        this.getModel();
      }
    },
  },
  created() {
    this.getFields();
    if (this.id) {
      this.getModel();
    }
  },
};
</script>

<style scoped></style>
